import React from 'react'

import { Button, ButtonProps } from '../../../../../global/button/Button'

type ModalButtonProps = React.PropsWithChildren<
  Omit<ButtonProps, 'size' | 'align' | 'className' | 'type' | 'fullWidth'>
>

export const ModalButton: React.FC<ModalButtonProps> = Button.New
